import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Text, Link, useResponsiveValue } from "braid-design-system";
import { useCallback } from "react";
import { useLink } from "../Accordion/Accordion.mjs";
import { text, link } from "./FooterLink.css.mjs";
const FooterLink = ({
  link: link$1,
  size = "small",
  tone = "secondary"
}) => {
  const { injectLinkContextToData } = useLink();
  const IconComponent = link$1.iconComponent;
  const onClickLink = useCallback((e) => {
    e.stopPropagation();
  }, []);
  const linkContent = /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", children: /* @__PURE__ */ jsxs(Text, { size, tone, children: [
    IconComponent && /* @__PURE__ */ jsx(Box, { component: "span", marginRight: "xsmall", children: /* @__PURE__ */ jsx(IconComponent, {}) }),
    /* @__PURE__ */ jsx(Box, { component: "span", className: text, children: link$1.title })
  ] }) });
  return /* @__PURE__ */ jsx(
    Link,
    {
      className: link,
      href: useResponsiveValue()({ mobile: link$1.mobileUrl, tablet: link$1.url }) || link$1.url,
      onClick: onClickLink,
      data: injectLinkContextToData(link$1.linkContext, {
        automation: link$1.linkContext.source
      }),
      rel: link$1.shouldNoFollow ? "nofollow" : void 0,
      target: link$1.openInNewWindow ? "_blank" : void 0,
      children: linkContent
    }
  );
};
export {
  FooterLink
};
